import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { hasTabPermission } from '@/utils/tabPages'
import { isEnterpriseViewOrg } from '@/utils/bidLevelActions'

function canPublicMaterials(params) {
  // 企业级用户直接放开公共资料库，不再依赖单独页签授权
  if (params && isEnterpriseViewOrg(params.orgType)) {
    return true
  }
  const pages = params && params.getters && params.getters['user/pages']
  const admin =
    params &&
    params.state &&
    params.state.superAdminName &&
    params.userName === params.state.superAdminName
  if (admin) return true
  return hasTabPermission(pages, 'trainingMaterials', '公共资料库')
}

const previewDetailPages = [
  {
    buttonName: '关联文件',
    name: 'previewMaterials',
    type: (params) =>
      params.currentRow && params.currentRow.dataFormat === 'article'
        ? 'path'
        : 'preview',
    path: (params) => {
      if (!params.currentRow || params.currentRow.dataFormat !== 'article') {
        return ''
      }
      const uid = params.currentRow.uid
      if (!uid) {
        return params.theme === 'publicMaterials'
          ? '/workbench/publicMaterials'
          : params.theme === 'materialLibrary'
          ? '/workbench/materialLibrary'
          : '/workbench/trainingMaterials'
      }
      const from =
        params.theme === 'publicMaterials'
          ? 'publicMaterials'
          : params.theme === 'materialLibrary'
          ? 'materialLibrary'
          : 'trainingMaterials'
      return (
        '/workbench/materialArticle/' +
        encodeURIComponent(uid) +
        '?from=' +
        from
      )
    },
    theme: 'preview',
    step: 'previewInfo',
    label: (params) => {
      if (!params.currentRow) return '预览或查看文件'
      if (params.currentRow.dataFormat === 'article') {
        return '查看图文：' + params.currentRow.dataName
      }
      return (
        (params.currentRow.dataFormat === 'video' ? '播放：' : '预览：') +
        params.currentRow.dataName
      )
    },
    previewParams: (params) => {
      if (!params.currentRow || params.currentRow.dataFormat === 'article') {
        return null
      }
      return {
        key: 'trainingMaterials',
        uid: params.currentRow.associatedFiles,
        type: params.currentRow.dataFormat,
        name: params.currentRow.dataName
      }
    }
  },
  {
    buttonName: '预览或下载文件',
    name: 'previewMaterials',
    type: 'preview',
    theme: 'preview',
    step: 'previewInfo',
    label: (params) => {
      if (!params.formValues) return '预览或查看文件'
      if (params.formValues.dataFormat === 'article') {
        return '查看图文：' + params.formValues.dataName
      }
      return (
        (params.formValues.dataFormat === 'video' ? '播放：' : '预览：') +
        params.formValues.dataName
      )
    },
    previewParams: (params) => {
      if (!params.formValues || params.formValues.dataFormat === 'article') {
        return null
      }
      return {
        key: 'trainingMaterials',
        uid: params.formValues.associatedFiles,
        type: params.formValues.dataFormat,
        name: params.formValues.dataName
      }
    }
  }
]

const materialLearnRecordDetailPage = {
  buttonName: '浏览量',
  type: 'drawerTable',
  name: 'materialLearnRecords',
  checkType: 'checkByUid',
  checkFun: 'training/getMaterialLearnRecords'
}

const materialLearnRecords = {
  name: 'materialLearnRecords',
  title: '资料浏览学习记录',
  direction: 'btt',
  size: '48%',
  tagInfo: (params) =>
    params.formValues && params.formValues.dataName
      ? '资料：' + params.formValues.dataName
      : '',
  rowData: (params) =>
    (params.state.training.materialLearnRecords &&
      params.state.training.materialLearnRecords.result) ||
    [],
  rowTotal: (params) =>
    (params.state.training.materialLearnRecords &&
      params.state.training.materialLearnRecords.totalSize) ||
    0,
  getListFun: 'training/getMaterialLearnRecords',
  columns: [
    {
      prop: 'userAccount',
      label: '用户',
      minWidth: '180px',
      overflow: false,
      overflowWidth: true
    },
    {
      prop: 'userName',
      label: '姓名',
      minWidth: '140px',
      overflow: false,
      overflowWidth: true
    },
    {
      prop: 'orgName',
      label: '所属机构',
      minWidth: '220px',
      overflow: false,
      overflowWidth: true
    },
    {
      prop: 'learnStartTime',
      label: '学习时间',
      width: '180px'
    },
    {
      prop: 'durationText',
      label: '学习时长',
      width: '120px'
    }
  ],
  hasPagination: true
}

const trainingMaterials = {
  trainingMaterials: {
    name: 'trainingMaterials',
    materialLearnRecords,
    componentTypes: ['navigate', 'check', 'tables', 'stepForm', 'drawerTable'],
    addFun: 'training/addTrainingMaterials',
    editFun: 'training/editTrainingMaterials',
    getListFun: 'training/getTrainingMaterialsList',
    deleteFun: 'training/deleteTrainingMaterials',
    detailPage: (params) => {
      const pages = [
        {
          buttonName: '新增',
          name: 'trainingMaterials',
          type: 'stepForm',
          theme: 'trainingMaterials',
          step: 'trainingMaterialsInfo',
          label: '新增培训教育资料'
        }
      ]
      if (canPublicMaterials(params)) {
        pages.push({
          buttonName: '公共资料库',
          type: 'path',
          path: '/workbench/publicMaterials'
        })
      }
      pages.push(
        {
          buttonNames: ['编辑', '查看'],
          name: 'trainingMaterials',
          type: 'stepForm',
          theme: 'trainingMaterials',
          step: 'trainingMaterialsInfo',
          label: '编辑培训教育资料',
          checkType: 'checkByUid',
          checkFun: 'training/getTrainingMaterialsInfo'
        },
        materialLearnRecordDetailPage,
        ...previewDetailPages
      )
      return pages
    },
    headButtons: (params) => {
      const names = ['新增']
      if (canPublicMaterials(params)) {
        names.push({ name: '公共资料库', icon: 'el-icon-folder-opened', type: '' })
      }
      return setCheckButtons(names)
    },
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      scope: 'orgOwned',
      dataType: [],
      applicableUsers: [],
      dataFormat: '',
      query: '',
      usageCount: null,
      pageviews: null
    },
    selectData: [
      {
        key: 'dataType',
        label: '资料类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.dataType
        },
        multiple: true,
        span: 12
      },
      {
        key: 'applicableUsers',
        label: '适用对象',
        type: 'select',
        options: (params) => {
          return params.dictionarys.applicableUsers
        },
        multiple: true,
        span: 12
      },
      {
        key: 'dataFormat',
        label: '资料格式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.dataFormat
        },
        checkByValue: true
      },
      {
        key: 'usageCount',
        label: '使用次数',
        type: 'input',
        placeholder: '查询大于等于输入值的数据'
      },
      {
        key: 'pageviews',
        label: '浏览量',
        type: 'input',
        placeholder: '查询大于等于输入值的数据'
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '资料名称/资料标签'
      }
    ],
    rowData: (params) => {
      return params.state.training.trainingMaterials.result
    },
    rowTotal: (params) => {
      return params.state.training.trainingMaterials.totalSize
    },
    columns: [
      {
        prop: 'dataName',
        label: '资料名称',
        minWidth: '200px',
        overflow: false,
        overflowWidth: true
      },
      {
        prop: 'dataAccess',
        label: '资料权限',
        width: '90px',
        tag: (params) => {
          return params.dictionarys.access
        }
      },
      { prop: 'learningTime', label: '学习课时', width: '90px' },
      { prop: 'usageCount', label: '使用次数', width: '90px' },
      { prop: 'pageviews', label: '浏览量', width: '90px', drillDown: true },
      {
        prop: 'dataFormatName',
        label: '资料格式',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.dataFormat
        }
      },
      {
        prop: 'files',
        label: '关联文件',
        width: '120px',
        isIdeal: '预览或下载',
        drillDown: true
      },
      {
        prop: 'dataLabelTags',
        label: '资料类型及标签',
        minWidth: '240px',
        tagList: true
      },
      {
        prop: 'applicableUserTags',
        label: '适用对象',
        minWidth: '200px',
        tagList: true
      },
      {
        label: '操作',
        width: '220px',
        buttons: setTableButtons(['查看', '编辑', '删除'])
      }
    ],
    hasPagination: true,
    addArray: true,
    formParams: {
      orgUid: (params) => {
        return params.userName === 'dpnadmin' ? '' : params.orgValue
      },
      dataName: '',
      // 机构用户与超管新增均默认公开；选私有则不进公共库
      dataAccess: '公开',
      dataType: [],
      dataLabels: '',
      applicableUsers: [],
      learningTime: null,
      dataSummary: '',
      dataFormat: '',
      associatedFiles: '',
      dataContent: '',
      coverImage: '',
      remark: '',
      fileLists: {
        associatedFiles: []
      }
    },
    formRules: (params) => {
      const isArticle =
        params.formValues && params.formValues.dataFormat === 'article'
      const isLink =
        params.formValues && params.formValues.dataFormat === 'link'
      const rules = {
        dataName: [
          { required: true, message: '资料名称不能为空', trigger: 'blur' },
          { max: 50, message: '资料名称不能超过50个字符', trigger: 'blur' }
        ],
        dataAccess: [
          { required: true, message: '请选择资料权限', trigger: 'change' }
        ],
        dataType: [
          {
            type: 'array',
            required: true,
            message: '请选择资料类型',
            trigger: 'change'
          }
        ],
        applicableUsers: [
          {
            type: 'array',
            required: true,
            message: '请选择适用对象',
            trigger: 'change'
          }
        ],
        learningTime: [
          { required: true, message: '学习课时不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: '学习课时必须为数字', trigger: 'blur' }
        ],
        dataSummary: [
          { max: 100, message: '资料简述不能超过100个字符', trigger: 'blur' }
        ],
        dataFormat: [
          { required: true, message: '请选择资料格式', trigger: 'change' }
        ]
      }
      if (isArticle) {
        rules.dataContent = [
          {
            required: true,
            message: '请编辑图文内容',
            trigger: 'change'
          }
        ]
      } else {
        rules.associatedFiles = [
          {
            required: true,
            message: isLink ? '请输入有效链接地址' : '请上传关联文件',
            trigger: 'change'
          }
        ]
      }
      return rules
    },
    formData: {
      card: '培训资料信息',
      manualUpload: (params) => {
        return params.pageStatus === 'check' ||
          (params.formValues &&
            (params.formValues.dataFormat === 'link' ||
              params.formValues.dataFormat === 'article'))
          ? false
          : true
      },
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        { key: 'dataName', label: '资料名称', type: 'input' },
        {
          key: 'dataAccess',
          label: '资料权限',
          type: 'select',
          options: (params) => {
            return params.dictionarys.access
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'dataTypes' : 'dataType'
          },
          label: '资料类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.dataType
          },
          multiple: true
        },
        { key: 'dataLabels', label: '资料标签', type: 'input' },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'users' : 'applicableUsers'
          },
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return params.dictionarys.applicableUsers
          },
          multiple: true
        },
        {
          key: 'learningTime',
          label: '学习课时',
          type: 'input',
          inputButton: '分钟',
          number: true
        },
        {
          key: 'dataSummary',
          label: '资料简述',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 2, maxRows: 6 },
          maxlength: 100,
          placeholder: '请输入资料简述'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check'
              ? 'dataFormatName'
              : 'dataFormat'
          },
          label: '资料格式',
          type: 'select',
          options: (params) => {
            return params.dictionarys.dataFormat
          },
          checkByValue: true
        },
        {
          key: (params) => {
            return params.formValues && params.formValues.dataFormat === 'link'
              ? 'associatedFiles'
              : null
          },
          label: '关联链接',
          type: 'input',
          placeholder: '请输入关联文件的有效查看地址链接'
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.dataFormat === 'article'
              ? 'dataContent'
              : null
          },
          label: '图文内容',
          type: 'richtext',
          coverKey: 'coverImage',
          span: 24
        },
        { key: 'remark', label: '备注', type: 'input' },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.dataFormat !== 'link' &&
              params.formValues.dataFormat !== 'article'
              ? 'associatedFiles'
              : null
          },
          label: '关联文件',
          type: (params) => {
            return params.formValues &&
              params.formValues.dataFormat !== 'link' &&
              params.formValues.dataFormat !== 'article'
              ? 'upload'
              : 'input'
          },
          url: (params) => {
            return params.formValues && params.formValues.dataFormat === 'video'
              ? '#'
              : params.formValues && params.formValues.dataFormat === 'image'
              ? params.state.uploadImage
              : params.state.uploadfile
          },
          listType: (params) => {
            return params.formValues && params.formValues.dataFormat !== 'image'
              ? 'text'
              : 'picture-card'
          },
          fileType: (params) => {
            return params.formValues ? params.formValues.dataFormat : ''
          },
          autoUpload: false,
          showFilelist: false,
          limit: 1
        }
      ]
    }
  },
  // 公共资料库：全页只读列表（从培训资料入口路由进入）
  publicMaterials: {
    name: 'publicMaterials',
    materialLearnRecords,
    componentTypes: ['navigate', 'check', 'tables', 'stepForm', 'drawerTable'],
    getListFun: 'training/getTrainingMaterialsList',
    headButtons: [],
    detailPage: [
      {
        buttonName: '查看',
        name: 'publicMaterials',
        type: 'stepForm',
        theme: 'publicMaterials',
        step: 'publicMaterialsInfo',
        label: '查看公共资料',
        checkType: 'checkByUid',
        checkFun: 'training/getTrainingMaterialsInfo',
        pageStatus: 'check'
      },
      materialLearnRecordDetailPage,
      ...previewDetailPages
    ],
    queryParams: {
      // 后端需按当前机构判断是否为企业级，从而放行公共资料库范围
      orgUid: (params) => {
        return params.orgValue
      },
      scope: 'public',
      dataType: [],
      applicableUsers: [],
      dataFormat: '',
      query: '',
      usageCount: null,
      pageviews: null
    },
    selectData: [
      {
        key: 'dataType',
        label: '资料类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.dataType
        },
        multiple: true,
        span: 12
      },
      {
        key: 'applicableUsers',
        label: '适用对象',
        type: 'select',
        options: (params) => {
          return params.dictionarys.applicableUsers
        },
        multiple: true,
        span: 12
      },
      {
        key: 'dataFormat',
        label: '资料格式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.dataFormat
        },
        checkByValue: true
      },
      {
        key: 'usageCount',
        label: '使用次数',
        type: 'input',
        placeholder: '查询大于等于输入值的数据'
      },
      {
        key: 'pageviews',
        label: '浏览量',
        type: 'input',
        placeholder: '查询大于等于输入值的数据'
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '资料名称/资料标签'
      }
    ],
    rowData: (params) => {
      const page = params.state.training.publicMaterials || {}
      return page.result || []
    },
    rowTotal: (params) => {
      const page = params.state.training.publicMaterials || {}
      return page.totalSize || 0
    },
    columns: [
      {
        prop: 'dataName',
        label: '资料名称',
        minWidth: '200px',
        overflow: false,
        overflowWidth: true
      },
      {
        prop: 'dataAccess',
        label: '资料权限',
        width: '90px',
        tag: (params) => {
          return params.dictionarys.access
        }
      },
      { prop: 'learningTime', label: '学习课时', width: '90px' },
      { prop: 'usageCount', label: '使用次数', width: '90px' },
      { prop: 'pageviews', label: '浏览量', width: '90px', drillDown: true },
      {
        prop: 'dataFormatName',
        label: '资料格式',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.dataFormat
        }
      },
      {
        prop: 'files',
        label: '关联文件',
        width: '120px',
        isIdeal: '预览或下载',
        drillDown: true
      },
      {
        prop: 'dataLabelTags',
        label: '资料类型及标签',
        minWidth: '200px',
        tagList: true
      },
      {
        prop: 'createOrgName',
        label: '创建机构',
        width: '120px',
        overflow: false,
        overflowWidth: true
      },
      {
        label: '操作',
        width: '100px',
        buttons: setTableButtons(['查看'])
      }
    ],
    hasPagination: true,
    formParams: null,
    formRules: null,
    formData: null
  },
  materialLearnRecords
}

// 查看详情复用培训资料表单配置（只读）
trainingMaterials.publicMaterials.formParams =
  trainingMaterials.trainingMaterials.formParams
trainingMaterials.publicMaterials.formRules =
  trainingMaterials.trainingMaterials.formRules
trainingMaterials.publicMaterials.formData = Object.assign(
  {},
  trainingMaterials.trainingMaterials.formData,
  {
    card: '公共资料信息',
    bottomButtons: setFormButtons(['取消'])
  }
)

export default trainingMaterials
